import {Rate} from 'antd';
import React from 'react';
import styled from 'styled-components';

interface RegisterRatingProps {
  color?: string;
  fontSize?: string;
  showLowerSection?: boolean;
  value?: number;
  lowerTextColor?: string;
  lowerTextFont?: string;
  marginRight?: string;
}

export const RegisterRating = (props: RegisterRatingProps) => {
  return (
    <StyledRatingWrapper lowerTextColor={props?.lowerTextColor}lowerTextFont={props.lowerTextFont} marginRight={props?.marginRight}>
      <StyledRating disabled value={props?.value ? props?.value : 2} style={{fontSize: props?.fontSize ? props?.fontSize : 13}} />
      {props.showLowerSection ? <div className={'reviews-text'}>Based on 3,200+ Reviews:</div> : <></>}
    </StyledRatingWrapper>
  );
};

const StyledRatingWrapper = styled.div<{lowerTextColor?: string; lowerTextFont?: string; marginRight: string}>`
  margin-right: ${p => p?.marginRight && p?.marginRight};
  .reviews-text {
    font-size: ${p => p?.lowerTextFont ? p?.lowerTextFont : '8px'};
    line-height: normal;
    font-family: 'Inter', sans-serif;
    color: ${p => p?.lowerTextColor ? p?.lowerTextColor : '#6c6e72'};
  }
`;
const StyledRating = styled(Rate)`
  .ant-rate-star:not(:last-child) {
    margin-right: 2px;
  }
  .ant-rate-star-full > div > .ant-rate-star-second > span > svg {
    fill: #F1AA3E;
  }
  .ant-rate-star-zero > div > .ant-rate-star-second {
    line-height: normal !important;
  }
  .ant-rate-star-zero > div > .ant-rate-star-second > span > svg {
    fill: rgba(241, 170, 62, 25%);
  }
`;
